import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './autoConfig';
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Chat from './Chat';
import Team from './Team';
import History from './History';

const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="chat" element={<Chat />} />
        <Route path="chat/:id" element={<Chat />} />
        <Route path="team" element={<Team />} />
        <Route path="history" element={<History />} />
        <Route path="history/:id" element={<History />} />
      </Routes>
    </MsalProvider>
  );
};

export default App;
